module.exports = __webpack_public_path__ + "bundles/EventSubmission/assets/images/icons/step1_add-3a7c2d98be7d21a6c53c66502da2a4fa.svg";


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/assets/images/icons/step1_add.svg
// module id = 1599
// module chunks = 0